export enum GoogleEventTypes {
    SELECT_ITEM = 'select_item',
    VIEW_ITEM = 'view_item',
    ADD_TO_CART = 'add_to_cart',
    BEGIN_CHECKOUT = 'begin_checkout',
    ADD_SHIPPING_INFO = 'add_shipping_info',
    ADD_PAYMENT_INFO = 'add_payment_info',
    PURCHASE = 'purchase'
}